<script lang="ts">
    export let title = "";
    export let description = "";

    const slots = $$slots;
</script>

<div class="gw-empty-state">
    {#if slots.icon}
        <div class="gw-empty-state__icon">
            <slot name="icon" />
        </div>
    {/if}
    <div class="gw-empty-state__title">
        {title}
    </div>
    <div class="gw-empty-state__description">
        {description}<slot name="descriptionIcon" />
    </div>
    {#if slots.footer}
        <slot name="footer" />
    {/if}
</div>

<style lang="postcss">
    .gw-empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
        padding: 30px;
    }
    .gw-empty-state__title {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: center;
    }
    .gw-empty-state__description {
        font-size: 10px;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
    }
</style>
